<template>
  <div class="container">
    <div class="wrap z-flex">
      <myLeft></myLeft>
      <div class="my-r">
        <myTop></myTop>
        <div class="box-con my-box">
          <myNav :activeMynav="'awards'"></myNav>
          <div class="bd">
              <div class="my-list">
                <el-row :gutter="20">
                  <el-col :span="8" v-for="(item,index) in list" :key="index">
                    <div class="item">
                      <div class="img-wrap" @click="getPoster(item)">
                        <el-image class="img" fit="cover" :src="item.imgUrl"></el-image>
                      </div>
                      <div class="title">{{item.matchTitle}}</div>
                      <div class="awards-row z-flex">
                        <i class="el-icon-trophy"></i>
                        <div class="awards">{{item.awards}}</div>
                        <!-- <div class="win-money">奖金￥{{item.amount}}</div> -->
                      </div>
                      <div class="time">获奖时间：{{item.time}}</div>
                    </div>
                  </el-col>
                </el-row>
                <!-- 结果为空 -->
                <el-empty class="empty-con" description="暂无数据" :image-size="180" v-if="list.length == 0">
                  <img class="img" src="../assets/images/default-list.png" slot="image"/>
                </el-empty>
                <!-- 分页 -->
                <el-pagination 
                  class="pagination" 
                  background 
                  layout="prev, pager, next" 
                  :page-size="length"
                  :total="totalNum"
                  hide-on-single-page
                  @current-change="changePage"
                >
                </el-pagination>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分享图片 -->
    <div class="poster" ref="poster">
      <div class="match-title">{{posterInfo.matchTitle}}</div>
			<div class="awards">{{posterInfo.awards}}</div>
			<div class="img-title">作品名称：《{{posterInfo.imgTitle}}》</div>
			<img class="img" :src="posterInfo.imgUrl" />
			<div class="poster-bottom z-flex z-flex-between">
				<div class="z-flex">
					<img class="avatar" :src="avatar"/>
					<div class="">
						<div class="username">{{username}}</div>
						<div class="vipname">{{starName}}</div>
					</div>
				</div>
			</div>
    </div>
    <!-- 分享弹窗 -->
    <el-dialog class="dialog-share" :visible.sync="dialogShare" width="450px">
      <img class="share-img" :src="posterUrl"/>
      <el-button class="btn-share" type="primary" icon="el-icon-share" size="medium">分享</el-button>
    </el-dialog>
  </div>
</template>

<script>
import myLeft from "@/components/my/myLeft";
import myTop from "@/components/my/myTop";
import myNav from "@/components/my/myNav";
import html2canvas from 'html2canvas';
import {mapState} from "vuex";
export default {
  components: {
    myLeft,
    myTop,
    myNav,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      avatar:'',
      username:'',
      starName:'',
      vipName:'',
      posterInfo:{
        matchTitle:'',
        awards:'',
        imgTitle:'',
        imgUrl:'',
      },
      posterUrl:'',
      dialogShare:false,
      length: 6,
      list:[],
    };
  },
  computed: {
    ...mapState(['vuex_user'])
  },
  mounted() {
    this.avatar = this.vuex_user.avatar;
    this.username = this.vuex_user.username;
    this.starName = this.vuex_user.qtclubWinStarName;
    this.vipName = this.vuex_user.vipName;
    this.getWinnerList();
    // 获取头像base64
    // this.$axios.api.request({
    //   url: "/api/qtclub/user/getImgBase64",
    //   method: "GET",
    //   data: {
    //     img: this.avatar,
    //   }
    // }, (res) => {
    //   this.avatar = res.data;
    //   // console.log('avatar_base64', res.data);
    // })
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getWinnerList();
    },
    getWinnerList(){
      const loading = this.$loading({target:'.my-list',});
      let offset = (this.curPage-1)*this.length;
      this.$axios.api.request({
        url: "/api/qtclub/user/getWinnerList",
        method: "GET",
        data: {
          offset: offset,
          length: this.length,
        }
      }, (res) => {
        loading.close();
        this.avatar = res.data.avatarBase64;
        this.starName = res.data.starName;
        this.list = res.data.list;
        this.totalNum = res.data.total;
      })
    },
    //生成海报
    getPoster(item){
      const loading =  this.$loading(
        {
          fullscreen:true, 
          text:'图片生成中,请稍后...',
        }
      );
      this.posterInfo.matchTitle = item.matchTitle;
      this.posterInfo.awards = item.awards;
      this.posterInfo.imgTitle = item.imgTitle;
      // 获取图片base64
      this.$axios.api.request({
        url: "/api/qtclub/user/getImgBase64",
        method: "GET",
        data: {
          img: item.imgUrl,
        }
      }, (res) => {
        console.log('url', item.imgUrl);
        this.posterInfo.imgUrl = res.data;
        console.log('data', this.posterInfo.imgUrl);
        this.$nextTick(()=>{
          html2canvas(this.$refs.poster).then((posterImg) => { 
            this.posterUrl = posterImg.toDataURL();
            loading.close();
            this.dialogShare = true;
          }).catch(() => {
            loading.close();   
            this.$message.error({
              message: '图片生成失败，请稍后重试!'
            });   
          });
        })
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.el-button{
  i{
    margin:0 5px 0 0;
  }
}
.my-box{
  .bd{
    padding: 20px;
    .my-list{
      .item{
        width:100%;
        margin-bottom: 20px;
        font-size: 14px;
        color: #999;
        .img-wrap{
          width:100%;
          height: 159px;
          overflow: hidden;
          border-radius: 4px;
          position: relative;
          cursor: pointer;
          .img{
            width:100%;
            height: 100%;
          }
        }
        .title{
          font-size: 15px;
          color: #333;
          margin:10px 0;
          height: 40px;
          line-height: 20px;
          @include textOverflowNum(2)
        }
        .time{
          text-align: right;
          padding-top: 6px;
          margin-top: 10px;
          border-top: $borderLight;
        }
        .awards-row{
          color: $colorMain;
          .el-icon-trophy{
            margin-right: 5px;
          }
          .awards{
            flex: 1;
            margin-right: 5px;
            @extend %textOverflow;
          }
        }
      }
    }
  }
}

.poster{
	width: 750px;
	padding: 30px 20px;
	background-color: #fff;
	z-index: 1;
	position: fixed;
  left: -999999999px;
  top: -9999999999px;
	.img{
		width: 100%;
		border-radius: 10px;
		margin-bottom: 20px;
	}
	.avatar{
		width: 120px;
		height: 120px;
		border-radius: 50%;
		margin-right: 30px;
	}
	.match-title{
		font-size:35px;
		font-weight: 700;
		text-align: center;
	}
	.awards{
		font-size:35px;
		font-weight: 700;
		text-align: center;
	}
	.img-title{
		font-size: 28px;
		margin: 25px 0;
		color: #777;
	}
	.username{
		height: 40px;
		line-height: 40px;
		font-size: 32px;
		max-width: 360px;
		margin-bottom: 16px;
		@extend %textOverflow;
	}
	.vipname{
		display: inline-block;
		font-size: 24px;
		color: #fff;
		padding: 2px 10px;
		border-radius: 6px;
		background-image: linear-gradient(to right, #16222A 100%, #3A6073 100%);
	}
}
.dialog-share{
  .share-img{
    width: 100%;
  }
  ::v-deep .el-dialog__header{
    padding:0;
  }
  ::v-deep .el-dialog__headerbtn{
    top: 0;
    right: -50px;
    font-size: 38px;
    .el-dialog__close{
      color: #fff;
    }
  }
  ::v-deep .el-dialog__body{
    padding:0;
    position: relative;
    .btn-share{
      position: absolute;
      right:20px;
      bottom:30px;
    }
  }
}
</style>
